var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", [_c("div", {
    staticClass: "submenus"
  }, [_c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.commissions
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.commissions ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Commissions")])])]), _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.conditionalsDiscounts
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.conditionalsDiscounts ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Conditionals discounts")])])])], 1), _vm.selectedTab === _vm.tabs.commissions ? _c("div", [_c("commission-list", {
    attrs: {
      role: _vm.role,
      target: "dfwa",
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.conditionalsDiscounts ? _c("div", [_c("ConditionalDiscountList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e()]) : _c("Error", {
    attrs: {
      error: {}
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };